import React, { useContext } from 'react';
export var ComboBoxContext = React.createContext(null);
export var useComboBox = function useComboBox() {
  return useContext(ComboBoxContext);
};